package org.example.project.enginevertrieb

import androidx.compose.runtime.*
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.launch
import org.example.project.dashboard.*
import org.example.project.settings.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
internal fun LinkedInConnectionPopup(onSaved: () -> Unit, onClose: () -> Unit) {
    val scope = rememberCoroutineScope()
    var token by remember { mutableStateOf("") }
    var connected by remember { mutableStateOf(false) }
    var busy by remember { mutableStateOf(false) }
    LaunchedEffect(Unit) { try { connected = LinkedInVertriebsindexApi.connection().linkedinVerbunden }
        catch (e: CancellationException) { throw e }
        catch (e: Exception) { AppDialogs.alert(e.message ?: "Verbindung konnte nicht geladen werden.") } }
    PopupEngineCard(windowKey = "linkedin-verbindung", zIndex = POPUP_ENGINE_MODAL_Z_INDEX + 40,
        widthPx = 580, heightPx = 350, minWidthPx = 420, minHeightPx = 300,
        centered = true, viewportAnchored = true, resizable = true, onClose = { if (!busy) { token = ""; onClose() } }) {
        Div({ style { height(100.percent); padding(24.px); boxSizing("border-box"); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(16.px) } }) {
            H3 { Text("LinkedIn verbinden") }
            Text(if (connected) "Für deinen Benutzer ist ein Token gespeichert." else "Verbinde dein eigenes LinkedIn-Konto.")
            Input(InputType.Password, attrs = {
                value(token); attr("autocomplete", "new-password"); attr("aria-label", "LinkedIn-Zugangstoken"); placeholder("LinkedIn-Zugangstoken")
                if (busy) disabled(); onInput { token = it.value }
                style { width(100.percent); height(40.px); boxSizing("border-box") }
            })
            Text("Kontakte und Nachrichten werden über die für deinen Token freigegebenen LinkedIn-Datenbereiche gelesen.")
            LumaticaButton("Verschlüsselt speichern", {
                busy = true
                scope.launch { try { connected = LinkedInVertriebsindexApi.connection(token).linkedinVerbunden; token = ""; onSaved(); onClose() }
                    catch (e: CancellationException) { throw e }
                    catch (e: Exception) { AppDialogs.alert(e.message ?: "Token konnte nicht gespeichert werden.") }
                    finally { busy = false } }
            }, enabled = !busy && token.isNotBlank(), variant = LumaticaButtonVariant.Action)
        }
    }
}
